import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/SeoHeaders";
import * as wActs from "../actions/website-actions";
import * as wConsts from "../consts/website-consts";
const lettersmap = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const letters = lettersmap.split("");

const lStyle = {border: "solid 1px #454545", display: "inline-block", padding: "3px", backgroundColor: "#e6e9ed", margin: "2px", fontSize: "16px", lineHeight: "18px"}
const sectHdr = {background: "#e6e9ed", textAlign: "left", padding: "7px", marginTop: "3px", fontSize: "13px"}
const defHdr = {textAlign: "left", padding: "7px", marginTop: "2px", fontSize: "13px"}
class Dictionary extends Component {

  constructor(props) {
    super(props);
    this.state = {
      letter: "ALL"
    }
  }


  componentDidMount() {
    this.props.dispatch(wActs.GetDictionaryWords());
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "dictionary" });
  }

  handleLetter(e,l) {
    e.preventDefault();
    this.setState({letter: l});
  }

  render() {
    if(!this.props.WebPage.Dictionary.Loaded) { return null; }
    let dict = this.props.WebPage.Dictionary.Result;
    let letter = dict[0].Letter;
    let tog = 0;
    return (
      <div className="main-content left" >
        <SeoHeaders Position={"Top"}/>
        <div className={"centered-content"}>
          <div style={lStyle}><a style={{cursor: "pointer"}} onClick={(e) => {this.handleLetter(e,"NUM")}}>NUM</a></div>
          {letters.map((v) => {
            return <div key={"letter-" + v} style={lStyle}><a style={{cursor: "pointer"}} onClick={(e) => {this.handleLetter(e,v)}}>{v}</a></div>
          })}
          <div style={lStyle}><a style={{cursor: "pointer"}} onClick={(e) => {this.handleLetter(e,"ALL")}}>ALL</a></div>
        </div>

        {dict.map((v,i) => {
          tog++;
          if(this.state.letter !== "ALL" && this.state.letter.toUpperCase() !== v.Letter.toUpperCase()) { return null; }
          return (
            <div key={"words-" + v.Word}>
              {tog % 2 === 0 &&
              <div style={defHdr}>{v.Definition}</div>
              }
              {tog % 2 !== 0 &&
              <div style={sectHdr}>{v.Definition}</div>
              }

            </div>
          )
        })}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(Dictionary);
